import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ES } from './es';

const resources = {
  es: {
    translation: { ...ES },
  },
};

i18next.use(initReactI18next).init({
  lng: 'es',
  debug: process.env.NODE_ENV !== 'test',
  resources,
  // React already escapes every text node it renders, so the default
  // i18next HTML-entity escape on interpolated values just produces
  // double-encoded artefacts ("Desde 30&#x2F;6&#x2F;2026" for
  // {{date}} = "30/6/2026"). Disable globally — safe because no
  // call site feeds t() output into dangerouslySetInnerHTML (greppable).
  interpolation: { escapeValue: false },
});

export { i18next };
